import { CHAIN_MAP } from '@/config/chains';
import { ROUTES } from '@/config/routes';
import type { ChainId } from '@/stores/slices/chainSlice';
import type { User, UserWallet } from '@/types/api';

export const getWalletForChain = (
  user: User | null | undefined,
  chain: ChainId
): UserWallet | null => {
  if (!user) return null;

  const numericId = String(CHAIN_MAP[chain].numericId);
  return user.wallets?.[numericId] ?? null;
};

export const getWalletAddressForChain = (
  user: User | null | undefined,
  chain: ChainId
): string | null => {
  return getWalletForChain(user, chain)?.address ?? null;
};

export const onboardingRouteForChain = (chain: ChainId): string => {
  const vm = chain === 'sol' ? 'svm' : 'evm';
  return `${ROUTES.ONBOARDING}?vm=${vm}`;
};
